import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import {
  CREATE_LESSON_PLAN_FAIL,
  DELETE_LESSON_PLAN,
  DELETE_LESSON_PLAN_SUCCESS,
  DeleteLessonPlanAction,
  FETCH_LESSON_PLANS
} from '../redux/lessonPlansReducer'

function* DeleteLessonPlanFlow(action: DeleteLessonPlanAction): Generator<any, void, any> {
  try {
    yield call(apiCall, {
      endpoint: `/tutors/lesson_plans/${action.payload.lessonPlanId}`,
      method: 'DELETE',
      params: {}
    })
    yield put(DELETE_LESSON_PLAN_SUCCESS())
    yield put(FETCH_LESSON_PLANS({ unitId: action.payload.unitId }))
  } catch (error) {
    yield put(CREATE_LESSON_PLAN_FAIL())
    console.log(error)
  }
}

export default function* DeleteLessonPlanSaga(): Generator<any, void, any> {
  yield takeLatest([DELETE_LESSON_PLAN], DeleteLessonPlanFlow)
}
